import React, { useState, useEffect } from 'react';
import FindingAPI from 'restAPI/FindingAPI';
import GlobalSettingAPI from 'restAPI/GlobalSettingAPI';
import _, { isEmpty } from 'lodash';
import { Alert } from 'antd';
import Vocabulary from 'components/Vocabulary';

const AcceptRiskThresholdAlert = ({ showWarning = true, findingIds, setIsAcceptRiskThresholdReached }) => {
    const [findingsWithThresoldAcceptedRisk, setFindingsWithThresoldAcceptedRisk] = useState([]);

    useEffect(() => {
        if (isEmpty(findingIds)) {
            setFindingsWithThresoldAcceptedRisk([]);
            return;
        }

        const { promise, cancel } = FindingAPI.getAcceptRiskCountBulk(findingIds);
        const { promise: promise1, cancel: cancel1 } = GlobalSettingAPI.getMaxAccpetRiskCount();

        Promise.all([promise, promise1])
            .then(([res, maxCount]) => {
                if (_.isNumber(maxCount.value)) {
                    const limitReachedList = [];
                    _.forEach(res, (value, key) => {
                        if (value >= maxCount.value) {
                            limitReachedList.push(key);
                        }
                    });
                    setFindingsWithThresoldAcceptedRisk(limitReachedList);
                }
            })
            .catch(console.error);

        return () => {
            cancel();
            cancel1();
        };
    }, [findingIds]);

    useEffect(() => {
        setIsAcceptRiskThresholdReached(findingsWithThresoldAcceptedRisk.length > 0 && showWarning);
    }, [showWarning, findingsWithThresoldAcceptedRisk, setIsAcceptRiskThresholdReached]);

    return (findingsWithThresoldAcceptedRisk.length > 0 && showWarning) ?
        <Alert type="warning" showIcon message={<>{findingsWithThresoldAcceptedRisk.join(',')} cannot be marked as <Vocabulary name="acceptRisk" />, since maximum threshold is reached.</>} />
        : null
};

export default AcceptRiskThresholdAlert;
